import type { ReactNode } from 'react';

import { Button } from '#/components/Button/Button';
import { useI18n } from '#/i18n/hooks/useI18n';

type Props = {
  atsIsEnabled: boolean;
  tabIndex?: number;
  applied: boolean;
  children?: ReactNode;
};

export function ScrollToApplyButton({
  atsIsEnabled,
  tabIndex,
  applied,
  children,
}: Props) {
  const { i18n } = useI18n();

  if (atsIsEnabled && applied) {
    return (
      <Button
        type="button"
        qaId="easy-apply-button"
        disabled
        variant="primary"
        tabIndex={tabIndex}
        icon={{ name: 'simple-check', color: 'brandGreen' }}
      >
        {children ?? i18n('Applied')}
      </Button>
    );
  }

  return (
    <Button
      type="link"
      href="#apply"
      variant="primary"
      anchorType="native"
      qaId="easy-apply-button"
      tabIndex={tabIndex}
      onClick={(event) => {
        event.preventDefault();
        document.getElementById('apply')?.scrollIntoView();
      }}
    >
      {children ?? i18n('Apply')}
    </Button>
  );
}
